import React, { useEffect, useState } from 'react';
import styles from './index.less';
import { history, useLocation } from 'umi';
import classnames from 'classnames/bind';
import { Badge, Space } from 'antd';

export interface INavigationItem {
  name: string;
  link: string;
  active?: boolean;
  invisible?: boolean;
  [key: string]: any;
}

type TSNProps = {
  list: INavigationItem[];
};

const SecondaryNavigation: React.FC<TSNProps> = ({ list }) => {
  const [navigationList, setNavigationList] = useState<INavigationItem[]>(list);
  const location = useLocation();
  const cx = classnames.bind(styles);

  const handleRouterChange = (link: string) => {
    if (link.startsWith('http') || link.startsWith('https')) {
      window.open(link, '_blank');
    } else {
      history.push(link);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const newList = navigationList.map((item, i) => {
      if (currentPath.indexOf(item.link) >= 0) {
        if (currentPath != item.link && item.link == '/sales') {
          return { ...item, active: false };
        } else {
          return { ...item, active: true };
        }
      } else {
        return { ...item, active: false };
      }
    });
    setNavigationList(newList);
  }, [location]);

  return (
    <>
      {navigationList.length > 0 ? (
        <div className={styles.navigation_wrapper}>
          <Space size={24} className={styles.navigation_content_wrapper}>
            {navigationList.map((item, index) => {
              const dom = (
                <div
                  className={cx({
                    navigation_item: true,
                    active: item.active,
                  })}
                  key={index}
                  onClick={() => {
                    handleRouterChange(item.link);
                  }}
                >
                  {item.name}
                </div>
              );
              if (item.approvalUnReadNum) {
                return (
                  <Badge overflowCount={99} size="small" count={item.approvalUnReadNum}>
                    {dom}
                  </Badge>
                );
              }
              return dom;
            })}
          </Space>
        </div>
      ) : null}
    </>
  );
};

export default SecondaryNavigation;
